<form [formGroup]="form" (ngSubmit)="submit()" class="shadow-lg rounded-xl">
  <div class="flex items-center bg-white rounded-full lg:rounded-xl overflow-hidden w-full mx-auto h-11">
    <button type="button" *ngIf="searchOptions.length > 1" [matMenuTriggerFor]="menu"
      class="flex items-center justify-between h-full px-3 bg-mg-main-blue-light bg-mg-accent-dark rounded-l-xl rounded-r-none">
      <mg-icon class="flex text-white" [iconName]="optionSearch.iconType" iconClass="w-[24px]"></mg-icon>
      <mg-icon class="flex text-white" iconName="arrow_drop_down" iconClass="w-[24px]"></mg-icon>
    </button>
    <button type="submit" [disabled]="!form.valid"
      class="bg-white text-mg-purple-dark rounded-sm p-1 transition-colors disabled:opacity-60">
      <mg-icon class="flex" iconName="search" iconClass="w-[24px]"></mg-icon>
    </button>
    <div class="relative flex items-center bg-white rounded-full lg:rounded-xl w-full mx-auto h-11">
      <div class="flex-grow">
        <input
          class="border-0 h-11 outline-none placeholder:text-secondary bg-card w-full px-2 text-gray-800 focus:ring-0"
          matInput formControlName="searchData" (ngModelChange)="updatedValue($event)" [matAutocomplete]="auto"
          matTooltip="{{validation_desc}}" placeholder="{{optionSearch.placeholder}}" type="text" />
      </div>
      <div class="flex items-center justify-center pr-3">
        <button (click)="reset()" *ngIf="form.valid || isActive" @scaleInOut type="button"
          class="text-gray-500 hover:text-black transition-colors">
          <mg-icon iconName="close" iconClass="w-[16px]"></mg-icon>
        </button>
      </div>
    </div>
    <mat-menu #menu="matMenu" class="">
      <button mat-menu-item *ngFor="let option of searchOptions" (click)="changeSelection(option)">
        <div class="grid grid-cols-[24px_auto] items-center gap-2 w-full">
          <mg-icon [iconName]="option.iconType" iconClass="text-mg-variant w-[24px]"></mg-icon>
          <span [ngClass]="{'font-bold text-mg-variant': option == optionSearch}">
            {{ option.label }}
          </span>
        </div>
      </button>
    </mat-menu>
  </div>
</form>
<mat-autocomplete #auto="matAutocomplete" class="!shadow-md">
  <mat-option (onSelectionChange)="submitOption(itemName.sDescripcion)" [matTooltipDisabled]="isSmallScreen"
    [matTooltip]="itemName.sDescripcion | titlecase" [ngClass]="{ 'hide-autocomplete': !showAutocomplete }"
    *ngFor="let itemName of observable | async" [value]="itemName.sDescripcion | titlecase">
    {{ itemName.sDescripcion | titlecase }}
  </mat-option>
</mat-autocomplete>